import React from 'react';
import { Calculator, Briefcase, User, ChevronRight, Check } from 'lucide-react';
import { servicesData, heroData } from '../../data/mock';
import MypesPromoBanner from './MypesPromoBanner';
import '../../styles/landing.css';

const iconMap = {
  Calculator: Calculator,
  Briefcase: Briefcase,
  User: User
};

const ServicesSection = () => {
  return (
    <section id="servicios" className="section section-light">
      <div className="container">
        <div className="section-header">
          <div className="section-label">Servicios</div>
          <h2 className="heading-1 section-title">Soluciones Contables Profesionales</h2>
          <p className="body-large section-subtitle">
            Servicios especializados para emprendedores, MYPES y profesionales independientes
          </p>
        </div>

        <div className="expertise-block" data-testid="expertise-block">
          <p className="expertise-tagline">
            {heroData.tagline}
          </p>
          <ul className="expertise-list">
            {heroData.specialties.map((item, idx) => (
              <li key={idx} className="expertise-item">
                <Check size={16} className="expertise-check" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
        
        <div className="services-grid">
          {servicesData.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div key={service.id} className="service-card">
                <div className="service-icon">
                  <IconComponent size={32} />
                </div>
                
                <h3 className="heading-2">{service.title}</h3>
                
                <ul className="service-list">
                  {service.items.map((item, itemIndex) => (
                    <li key={itemIndex}>
                      <ChevronRight size={16} className="service-list-icon" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        <MypesPromoBanner />
      </div>
    </section>
  );
};

export default ServicesSection;
